import React from 'react';
import { AlertTriangle } from 'react-feather';

interface AuthErrorMessageProps {
  error: string;
  className?: string;
}

const AuthErrorMessage: React.FC<AuthErrorMessageProps> = ({ error, className = '' }) => {
  if (!error) return null;

  return (
    <div className={`rounded-md bg-red-50 p-4 animate-slideIn ${className}`}>
      <div className="flex">
        <AlertTriangle className="h-5 w-5 text-red-400" />
        <div className="ml-3">
          <p className="text-sm text-red-700">{error}</p>
        </div>
      </div>
    </div>
  );
};

export default AuthErrorMessage;